import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    max-width: 100%;
    
    /* background-color: red; */
    justify-content: center;
    /* align-items: center; */
`
export const Img = styled.img`
    background-color: transparent;
    width: 15%;
    margin: 5%;

`